<template>
    <div>
        <div class="profile portal">
            <div class="update-password">
                <h4 class="title">{{ $page.props.lang.updatePassword || "Update password" }} </h4>
                <p class="desc">{{ $page.props.lang.updatePasswordDescsription || "Ensure your account is using a long, random password to stay secure." }}</p>
                
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.currentPassword || "Current password" }}</p>
                    <v-text-field type="password" v-model="form.current_password"
                    background-color="#FFFFFF" solo outlined flat dense
                    :error-messages="responseErrors.current_password" @focus="responseErrors.current_password=''"></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.newPassword || "New password" }}</p>
                    <v-text-field v-model="form.password"
                    type="password"
                    background-color="#FFFFFF" solo outlined flat dense
                    :error-messages="responseErrors.password" @focus="responseErrors.password=''"></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.confirmPassword || "Confirm password" }}</p>
                    <v-text-field v-model="form.password_confirmation"
                    type="password"
                    background-color="#FFFFFF" solo outlined flat dense
                    :error-messages="responseErrors.password_confirmation" @focus="responseErrors.password_confirmation=''"></v-text-field>
                </div>
                
                <v-btn @click="updatePassword" :loading="updating" color="primary">{{ $page.props.lang.updatePasswordButton || "Update"}}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import PortalLayout from '@/js/Layouts/PortalLayout'
import ProfileLayout from '@/js/Layouts/ProfileLayout'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title: this.organization.name + ' - ' + (this.$page.props.lang.updatePassword || "Update Password") 
        }
    },
    layout: (h, page) => {
      return h(PortalLayout, [
        h(ProfileLayout, [page]),
      ])
    },
    components: {
    },
    props: {
        member: Object,
        lang: Object,
        organization: Object
    },
    data(){
        return {
            form: this.$inertia.form({
                current_password: '',
                password: '',
                password_confirmation: '',
            }),
            updating: false,
            responseErrors: {}
        }
    },
    methods: {
        updatePassword() {
            this.updating = true
            axios.post('/users/reset_password', this.form)
                .then(response => {
                    var messageType = "success";

                    if (response.data.status !=='OK') {
                        messageType = "error";
                    }

                    EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: messageType,
                            timeout: 10000
                        });
                        
                    this.form.reset()
                })
                .catch(error => {
                    this.responseErrors = error.response.data.errors
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                })
                .then(() => {
                    this.updating = false
                })
        }
    }
}
</script>